import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { FiEye, FiPaperclip, FiDownload } from 'react-icons/fi';
import { fetchAttachmentBlob } from '../services/api';

function AttachmentViewer({ projectId, testCaseId, attachment }) {
  const [src, setSrc] = useState(null);
  const [fullscreen, setFullscreen] = useState(false);

  useEffect(() => {
    let revoked = false;
    if (projectId && testCaseId && attachment?.id) {
      fetchAttachmentBlob(projectId, testCaseId, attachment.id).then((url) => {
        if (!revoked) setSrc(url);
      }).catch(() => {});
    }
    return () => {
      revoked = true;
      if (src) URL.revokeObjectURL(src);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, testCaseId, attachment?.id]);

  if (!src) return <div className="observation-thumb-placeholder">Chargement...</div>;

  return (
    <>
      <button type="button" className="observation-attachment" onClick={() => setFullscreen(true)} style={{ background: 'none', border: 'none', font: 'inherit', color: 'inherit', textAlign: 'left', padding: 0, cursor: 'pointer' }}>
        <img src={src} alt={attachment.filename} className="observation-thumb" />
        <div className="observation-filename">{attachment.filename}</div>
      </button>
      {fullscreen && (
        <div className="observation-fullscreen">
          <button type="button" className="observation-fullscreen-backdrop" onClick={() => setFullscreen(false)} aria-label="Fermer" tabIndex={-1} style={{ position: 'absolute', inset: 0, background: 'transparent', border: 'none', cursor: 'default', zIndex: 0, outline: 'none' }} />
          <img src={src} alt={attachment.filename} />
          <a
            href={src}
            download={attachment.filename}
            className="observation-download"
            onClick={(e) => e.stopPropagation()}
            title="Telecharger"
          >
            <FiDownload />
          </a>
        </div>
      )}
    </>
  );
}

export default function ObservationModal({ show, onClose, testCase, projectId, commentaire }) {
  if (!testCase) return null;

  const attachments = testCase.attachments || [];

  return (
    <Modal show={show} onClose={onClose} title={`Observation - ${testCase.ct_id}`} icon={<FiEye />} size="md">
      <div className="mb-2">
        <span className="small fw-500" style={{ color: 'var(--gray-500)' }}>{testCase.cas_test}</span>
      </div>

      {/* Commentaire / Observation */}
      <div className="mb-3">
        <span className="form-label small fw-500 d-block">Observation / Cause</span>
        {commentaire ? (
          <div className="observation-comment">{commentaire}</div>
        ) : (
          <div className="text-muted small">Aucune observation saisie.</div>
        )}
      </div>

      {/* Pieces jointes / Screenshots */}
      {attachments.length > 0 && (
        <div>
          <span className="form-label small fw-500 d-flex align-items-center gap-1">
            <FiPaperclip /> Captures d'ecran ({attachments.length})
          </span>
          <div className="observation-gallery">
            {attachments.map(att => (
              <AttachmentViewer
                key={att.id}
                projectId={projectId}
                testCaseId={testCase.id}
                attachment={att}
              />
            ))}
          </div>
        </div>
      )}

      {!commentaire && attachments.length === 0 && (
        <div className="text-center text-muted py-3" style={{ fontSize: '0.82rem' }}>
          Aucune observation ni capture pour ce cas de test.
        </div>
      )}
    </Modal>
  );
}
